import { ACCOUNT_QUERY_KEY, queryClient } from '@hcs/http-clients';
import { Account } from '@hcs/types';

export const getHcAuthPrincipals = () => {
  const account = queryClient.getQueryData<Account>([ACCOUNT_QUERY_KEY]);
  return {
    'HC-Auth-Principals': [
      `Organization=${account?.currentOrganization.id}`,
      `User=${account?.user.id}`,
      ...(account?.user.roles.map((r) => `Role=${r.id}`) || []),
    ].join('&'),
  };
};

export const getHcAuthHeader = () => {
  return {
    'Hc-Auth-Token': queryClient.getQueryData<Account>([ACCOUNT_QUERY_KEY])
      ?.validity.token,
  };
};
